module.exports = __webpack_public_path__ + "img/Character_Aloy_Thumb.8d35aa05.png";